import { forwardRef, type SVGProps } from 'react';

export type RemoveProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const Remove = forwardRef<SVGSVGElement, RemoveProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="currentColor" viewBox="0 0 32 32">
    <path
      d="M24 16.08l-16-.16"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
));
Remove.displayName = 'Remove';
